var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 7.05023,
    cy: 7.05029,
    r: 2,
    transform: "rotate(135 7.05023 7.05029)",
    fill: "#FF007A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 5,
    cy: 12,
    r: 2,
    transform: "rotate(90 5 12)",
    fill: "#FF007A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 7.05029,
    cy: 16.9498,
    r: 2,
    transform: "rotate(45 7.05029 16.9498)",
    fill: "#FF007A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12,
    cy: 19,
    r: 2,
    fill: "#FF007A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 16.9498,
    cy: 16.9497,
    r: 2,
    transform: "rotate(135 16.9498 16.9497)",
    fill: "#FF007A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19,
    cy: 12,
    r: 2,
    transform: "rotate(90 19 12)",
    fill: "#FF007A"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9497,
    cy: 7.05023,
    r: 2,
    transform: "rotate(45 16.9497 7.05023)",
    fill: "#FF007A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 12,
    cy: 5,
    r: 2,
    fill: "#FF007A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingStep2);
export default __webpack_public_path__ + "static/media/loading-step2.c6c69e7df5ffdd48fe2859f87718f383.svg";
export { ForwardRef as ReactComponent };